import React from "react";
import { ButtonBase } from "@mui/material";
import { AvailableLoanOptionButton } from "../icons/available-loan-option-buton";
import { SubtitleSpan } from "../../views/comparison_views/molecules/ui-utils";

export const LoanOptionButton = ({ subtitle, onClick, selected, title }) => (
  <ButtonBase
    className={
      selected ? "loan-option-button-base selected" : "loan-option-button-base"
    }
    onClick={onClick}
    disableRipple
  >
    <div className="loan-option-button-background">
      <AvailableLoanOptionButton width={70} height={90} />
    </div>
    <div className="loan-option-button-title">
      <div className="button-title">{title}</div>
    </div>
    <div className="loan-option-button-subtitle">
      <SubtitleSpan>{subtitle}</SubtitleSpan>
    </div>
  </ButtonBase>
);
